/* ============================================================
   Wishlist engine — localStorage, global API + change event
   API:  Wishlist.add(handle) / .remove(handle) / .toggle(handle)
         .has(handle) / .getAll() / .count() / .clear() / .refresh()
   Event: document "wishlist:change" → detail { handles:[], count:n }
   Stores product HANDLES, newest first.
   ============================================================ */
(function () {
  if (window.Wishlist && window.Wishlist.__ready) return;

  var KEY = 'hm_wishlist_v1';
  var memFallback = null;

  function canStore() {
    try { localStorage.setItem('__t', '1'); localStorage.removeItem('__t'); return true; }
    catch (e) { return false; }
  }
  var STORAGE_OK = canStore();

  function read() {
    if (!STORAGE_OK) return memFallback ? memFallback.slice() : [];
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    var clean = [], seen = {};
    arr.forEach(function (h) { if (typeof h === 'string' && h && !seen[h]) { seen[h] = 1; clean.push(h); } });
    if (STORAGE_OK) { try { localStorage.setItem(KEY, JSON.stringify(clean)); } catch (e) {} }
    else { memFallback = clean.slice(); }
    emit(clean);
    return clean;
  }

  function emit(arr) {
    var handles = arr || read();
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { handles: handles.slice(), count: handles.length }
    }));
  }

  var Wishlist = {
    __ready: true,
    storageAvailable: STORAGE_OK,
    getAll: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      if (!handle) return;
      var arr = read();
      if (arr.indexOf(handle) === -1) { arr.unshift(handle); write(arr); }
    },
    remove: function (handle) {
      var arr = read(), i = arr.indexOf(handle);
      if (i !== -1) { arr.splice(i, 1); write(arr); }
    },
    toggle: function (handle) {
      if (!handle) return false;
      var arr = read(), i = arr.indexOf(handle);
      if (i === -1) { arr.unshift(handle); write(arr); return true; }
      arr.splice(i, 1); write(arr); return false;
    },
    clear: function () { write([]); },
    refresh: function () { emit(read()); }
  };

  // sync across tabs/windows
  window.addEventListener('storage', function (e) { if (e.key === KEY) emit(read()); });

  window.Wishlist = Wishlist;

  // broadcast once on load so any late-rendered badge/heart picks up state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { emit(read()); });
  } else { emit(read()); }
})();

/* ============================================================
   Wishlist heart UI — global click/paint for every page
   (collection cards, PDP, wishlist page). A button just needs
   data-wishlist-toggle + data-wishlist-handle="<handle>".
   ============================================================ */
(function () {
  if (window.__hmWishUI) return;
  window.__hmWishUI = true;

  function paintOne(btn, on) {
    btn.classList.toggle('is-wished', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }

  window.__hmWishPaint = function () {
    if (!window.Wishlist) return;
    var set = {};
    window.Wishlist.getAll().forEach(function (h) { set[h] = 1; });
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      paintOne(btn, !!set[btn.getAttribute('data-wishlist-handle')]);
    });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!window.Wishlist) return;
    var on = window.Wishlist.toggle(btn.getAttribute('data-wishlist-handle'));
    paintOne(btn, on);
    if (on) { btn.classList.remove('hm-wish--pop'); void btn.offsetWidth; btn.classList.add('hm-wish--pop'); }
  });

  document.addEventListener('wishlist:change', function () { window.__hmWishPaint(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__hmWishPaint);
  } else {
    window.__hmWishPaint();
  }
})();